import * as React from 'react';
import { isNil } from 'lodash';
import * as grid from 'view/styles/grid';
import { ResultContainer, ResultContentContainer, IconContainer } from './styled';

const DEFAULT_RESULT_PADDING = grid.multiple(2).px;
const DEFAULT_ICON_SIZE = grid.multiple(4).px;
const DEFAULT_ICON_MARGIN = grid.multiple(2).px;

export interface Props {
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    iconSize?: number;
    iconMargin?: number;
    padding?: number;
    alignItems?: 'center' | 'normal';
    content?: React.ReactNode;
    className?: string;
    centerAlignLeftIcon?: boolean;
    centerAlignRightIcon?: boolean;
    dataTestId?: string;
}

const IconCardLayout: React.StatelessComponent<Props> = ({
    leftIcon,
    rightIcon,
    content,
    iconSize,
    iconMargin,
    padding,
    alignItems,
    className,
    centerAlignLeftIcon,
    centerAlignRightIcon,
    dataTestId,
}) => {
    const iconSizeWithDefault = !isNil(iconSize) ? `${iconSize}px` : DEFAULT_ICON_SIZE;
    const iconMarginWithDefault = !isNil(iconMargin) ? `${iconMargin}px` : DEFAULT_ICON_MARGIN;
    const paddingWithDefault = !isNil(padding) ? `${padding}px` : DEFAULT_RESULT_PADDING;

    return (
        <ResultContainer
            data-test-id={dataTestId}
            className={className}
            padding={paddingWithDefault}
            align={alignItems || 'center'}
        >
            {leftIcon && (
                <IconContainer
                    iconMargin={iconMarginWithDefault}
                    iconSize={iconSizeWithDefault}
                    isCenterAlignIcon={centerAlignLeftIcon}
                >
                    {leftIcon}
                </IconContainer>
            )}
            <ResultContentContainer>{content}</ResultContentContainer>
            {rightIcon && (
                <IconContainer
                    iconMargin={DEFAULT_ICON_MARGIN}
                    iconSize={iconSize ? `${iconSize}px` : DEFAULT_ICON_SIZE}
                    isCenterAlignIcon={centerAlignRightIcon}
                    right
                >
                    {rightIcon}
                </IconContainer>
            )}
        </ResultContainer>
    );
};

export default IconCardLayout;
